export default "__VITE_ASSET__CzSvX0I$__";